import React from 'react'
import styled from 'styled-components'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'

// Icons
import { ReactComponent as WarningTriangle } from 'icons/warning-triangle-64.svg'

// Components
import ErrorMessage from 'components/ErrorMessage'

const GenericError = styled(ErrorMessage.Generic)`
  margin: auto;
  max-width: 320px;
  min-height: min-content;
`

interface InspectorErrorProps {
  error: string
  reason?: string
}

const ErrorTemplate = ({
  title = 'Inspector not available',
  message,
}: {
  title?: string
  message: React.ReactNode
}) => (
  <GenericError
    title={title}
    description={message}
    icon={<WarningTriangle />}
    iconSize="medium"
  />
)

const InspectorError: React.FC<InspectorErrorProps> = ({ error, reason }) => {
  if (error === 'NOT_FOUND') {
    if (reason === 'INSPECTOR_NOT_SUPPORTED') {
      return (
        <ErrorTemplate
          message={
            <>
              The Inspector couldn’t load because the document is outdated. Save
              the document using the latest version of Sketch and try again.
            </>
          }
        />
      )
    }

    return (
      <ErrorTemplate
        message={
          <>
            The Inspector isn’t available because the document didn’t load. Make
            sure you’re using the correct URL and try again — or{' '}
            <a href={`${SKETCH_WEBSITE}/support/contact/`}>contact us</a>
          </>
        }
      />
    )
  }

  return (
    <ErrorTemplate
      message={
        <>
          The Inspector couldn’t load because there’s an error in the document.
          Try uploading your document again, or{' '}
          <a href={`${SKETCH_WEBSITE}/support/contact/`}>contact us</a>
        </>
      }
    />
  )
}

export default InspectorError
